<template>


<div class="row">

  
    <!-- GRID do ponto eletronico -->              
    <!-- GRID do ponto eletronico -->              
    <!-- GRID do ponto eletronico -->  
  <div class="col-6">
            
    <div>

    <b-table
      small hover striped sticky-header="556px"
      :items="pontoeletronicomarcacao"
      :fields="fields"
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable      
    >
     <template #cell(foto_url)="data">
        <img :src="data.value" alt="Foto do Ponto" style="max-width: 100px; max-height: 100px;" />
      </template>

      <template v-slot:cell(dt_servico)="data">
      <div :class="getBackgroundColor(data.item)">
        {{ data.value }}
      </div>
    </template>

    <!-- Definindo a classe CSS condicional para a coluna 'dt_gravacao' -->
    <template v-slot:cell(dt_gravacao)="data">
      <div :class="getBackgroundColor(data.item)">
        {{ data.value }}
      </div>
    </template>

    </b-table>

  </div> 

    <!-- registrar ponto-->              
    <!-- registrar ponto--> 
    <!-- registrar ponto--> 
  </div>
    <div class="col-6">    
      <div class="atividades-rfilancamentos ml-4 mr-4" >

              <b-form> 
                          <b-row>
                  <b-col cols="2" class="mt-2 pr-4" >
                      <b-form-group label="" label-for="pe-foto">
                        <b-img                         
                            class="mb-2" 
                            v-model="operador.foto_url"                         
                            v-bind="mainProps" rounded alt="Foto"                        
                            :src="operador.foto_url"
                            height="160"
                            width="120"
                        >
                        </b-img>
                      </b-form-group>
                      
                  </b-col>  
                
                  <b-col>

                    <!-- NOME -->     
                    <b-row >
                        <b-col cols=12 class="mt-3 ">
                            <b-form-input id="pe-nome" 
                                type="text" 
                                readonly                       
                                v-model="operador.nome"                         
                                placeholder="Nome funcionário" 
                            />                        
                        </b-col>
                    </b-row>


                    <!-- FUNÇÃO e CHN -->     
                    <b-row >
                      
                        <b-col cols=8 class="mt-3">
                            <b-form-input id="pe-funcao" 
                                type="text"   
                                readonly                     
                                v-model="operador.funcao"                         
                                placeholder="Função" 
                            />                        
                        </b-col>

                        <b-col cols=4 class="mt-3">                        
                            <b-form-input id="pe-celular" only
                                type="text"
                                readonly                               
                                v-model="operador.celular"                         
                                placeholder="Celular" 
                            />
                        </b-col>     
                        
                                                                      
                    </b-row>

                    <!-- RE e CELULAR -->     
                  
                    <b-row >
                        <b-col cols=3 class="mt-3 mb-3">
                            <div>   
                                    <b-form-datepicker id="esc_data_servico"  v-model="valor_dtservico"  required placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                                </div>                     
                        </b-col>                 
                        <b-col cols=5 class="mt-3 mb-3">
                            <b-form-input id="pe-registro" 
                                type="text"                            
                                required                        
                                v-model="valor_operador" 
                                @keyup.enter="loadOperador(), getBackgroundColor()"                                          
                                placeholder="1818" 
                            />                        
                        </b-col> 
                    

                        

    
                    </b-row>

                                


                  </b-col>              
              </b-row>





      <div>    
        
        <b-card class="mt-3 mb-3 text-center" v-for="(item, index) in pontoeletronico" :key="index"     
        :header="item.legenda"     
        :title="item.title">
        
        <b-card-text>
          <b-row>
            <b-col cols=4>
              Linha.: {{item.linha}}    
            </b-col>
            <b-col cols=4>
              Tabela.: {{item.tabela}}          
            </b-col>
            <b-col cols=4>
              Carro.: {{item.carro}}          
            </b-col>
          </b-row>
          <b-row>
            <b-col cols=4>
              Horário chegada programado.: {{item.chegada}}          
            </b-col>
            <b-col cols=4>
              Horário saida programado.: {{item.saida}}          
            </b-col>        
          </b-row>
        </b-card-text>        
        <template #footer>
          <div>            
            <b-button v-b-modal.modal-lg variant="primary" block @click="postPontoMarcacao(index)">Registrar Ponto</b-button> 
          </div>
        </template>      
      </b-card>

        
        
      </div>

            
        </b-form>


      

      </div> 
  </div>      
    <!-- Modal Camera ponto--> 
    

    <div>
      <b-modal id="modal-lg" size="lg" title="Registrar foto ponto eletronico">  
        <div id="app" class="web-camera-container">
  <div class="camera-button">
      <button type="button" class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
        <span v-if="!isCameraOpen">Open Camera</span>
        <span v-else>Close Camera</span>
    </button>
  </div>
  
  <div v-show="isCameraOpen && isLoading" class="camera-loading">
    <ul class="loader-circle">
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>
  
  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
    
    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
      
    <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
    
    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
  </div>
  
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <button type="button" class="button" @click="takePhoto">
      <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
    </button>
  </div>
  
  <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
      Download
    </a>
  </div>
</div>        
        
    </b-modal>

    </div>

</div>

  
  



</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import { mapState } from 'vuex' 
import moment from 'moment'


export default {
  

  name: 'PlanejamentoEscalaModelo',    
  
      computed : { ... mapState (['user'],),

props: {
    items: {
      type: Array,
      required: true,
    },
  },

    

   
    } ,

  data: function() {        
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,            
            // 21/07/2023 as 16:00h
            valor_operador: '',
            valor_dtservico:'',
            operador:[],
            pontoeletronico:[],
            pontoeletronicomarcacao:[],
            selectedCard: null,            

            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            link: '#',

          
          fields: [
                { key: 'nsr', label: 'NSR', sortable: true },   
                { key: 'foto_url', label: 'Foto', sortable: true }, 
                { key: 'dt_servico', label: 'Data Operação', sortable: true, formatter: (value, key, pontoeletronicomarcacao) => {
                    return moment(pontoeletronicomarcacao.dt_servico).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },    
                { key: 'dt_gravacao', label: 'Ponto registrado', sortable: true, formatter: (value, key, pontoeletronicomarcacao) => {
                    return moment(pontoeletronicomarcacao.dt_gravacao).format('DD/MM/YYYY  HH:mm').replace('Data inválida','-') ; }  },                                                                             
                { key: 'linha', label: 'Linha', sortable: true },                                                                             
                { key: 'tabela', label: 'Tabela', sortable: true },                                                                              
                { key: 'legenda', label: 'Legenda', sortable: true }, 
          { key: 'codigohash', label: 'Hash', sortable: true }, 
          
          ]
            
        }        
        
    },

    
    


    methods: {

      getBackgroundColor(item) {
        if (item.dt_servico && item.dt_gravacao) {
          return item.dt_servico === item.dt_gravacao ? 'bg-green' : 'bg-yellow';
        }
        // Caso uma das células não esteja preenchida, não aplicamos cor de fundo
        return '';
      },

      

      /* camera*/
      toggleCamera() {
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    
    createCameraElement() {
      this.isLoading = true;
      
      const constraints = (window.constraints = {
				audio: false,
				video: true
			});


			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
          this.isLoading = false;
					alert("May the browser didn't support or there is some errors.");
				});
    },
    
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },
    
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      
      this.isPhotoTaken = !this.isPhotoTaken;
      
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },
    
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
    .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },



      /*camera */

      


        async loadMarcacoesDiaria() { 
           let corpo = {                           
            "dt_servico": `${this.valor_dtservico}`,            
            "id_operador": `${this.operador.id_funcionario}`
            
          };             
          const url = `${baseApiUrl}/pontoeletronico/consultamarcacao`
          axios.post(url,corpo).
          then(res => { this.pontoeletronicomarcacao = res.data }
          )
          .catch(showError)                    
        },

          async postPontoMarcacao(index) {                           
            let corpo = {                                         
            "id_empresa": `${this.user.id_empresa}`,
            "id_empresa_grupo": `${this.pontoeletronico[index].id_empresa_grupo}`, 
            "dt_servico": `${this.valor_dtservico}`, 
                 "id_filial" : `${this.pontoeletronico[index].id_filial}`, 
                    "id_linha" : `${this.pontoeletronico[index].id_linha}`,                     
                    "id_funcionario" : `${this.operador.id_funcionario}`,
                    "id_funcao" : `${[this.operador.id_funcao_erp]}`, 
                    "identificador_coletor" : 2, 
                    "id_funcionario_cadastro" : `${[this.user.id_funcionario]}`,                     
                    "marcacao" : 0, 
                    //"id_linha" : `${[this.pontoeletronico[index].id_linha]}`, 
                    "id_tabela" : `${[this.pontoeletronico[index].id_tabela]}`, 
                    "id_servico" : `${[this.pontoeletronico[index].id_servico]}`,   
                    "id_legenda" : `${[this.pontoeletronico[index].id_legenda]}`,   
            }; 
            
          const url = `${baseApiUrl}/pontoeletronico/marcacao`
          axios.post(url,corpo).
          then(res => { this.operador = res.data 
              this.loadOperador()              
            }           
          )
          .catch(showError)          
        },

      
        async loadEscalaDiaria() { 
           let corpo = {                           
            "dt_servico": `${this.valor_dtservico}`,
            "id_empresa": `${this.user.id_empresa}`,  
            "id_operador": `${this.valor_operador}`
            
          };             
          const url = `${baseApiUrl}/pontoeletronico/escala`
          axios.post(url,corpo).
          then(res => { this.pontoeletronico = res.data }
          )
          .catch(showError)                    
        },  

        async loadOperador() { 
            let corpo = {                             
            "registro": `${this.valor_operador}`,
            "id_empresa": `${this.user.id_empresa}`
            }; 
            
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo)
          .then(res => { this.operador = res.data 
              this.loadEscalaDiaria()
              this.loadMarcacoesDiaria()
            }           
          )
          .catch(showError)          
        },

        resetOperador() {                  
          this.valor_operador =''          
        },


       
    },

    

  mounted() {
    
  },

   

 
  };

  





</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>








/*//////////////////*/


#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;
    
}

/* Definindo as classes CSS para os backgrounds verde e amarelo */
.bg-green {
  background-color: green;
}

.bg-yellow {
  background-color: yellow;
}



</style>